import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ApiUrls } from '../models/api-urls.model';
import { Town } from '../models/town.model';

@Injectable({ providedIn: 'root' })
export class ApiService {
  private readonly http = inject(HttpClient);

  getTowns() {
    return this.http.get<Town[]>(ApiUrls.towns());
  }
}
